import { FormHelperText, InputLabel } from '@mui/material';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';

interface Props {
  name: string;
  id: string;
  errorText: string;
  isRequired: boolean;
  value: Dayjs | string | null;
  label: string;
  onChange: (newDate: Dayjs | null) => void;
}

const DatePickerWithLabel = ({
  name,
  id,
  errorText,
  isRequired,
  value,
  label,
  onChange,
}: Props) => {
  const pickerValue = value ? dayjs(value) : null;
  const resolvedValue = pickerValue?.isValid() ? pickerValue : null;

  return (
    <>
      <InputLabel shrink required={isRequired} htmlFor={name} error={!!errorText}>
        {label}
      </InputLabel>
      <DesktopDatePicker
        format="MM/DD/YYYY"
        value={resolvedValue}
        onChange={onChange}
        slotProps={{
          textField: {
            fullWidth: true,
            id,
            name,
            error: !!errorText,
          },
        }}
      />
      {errorText && (
        <FormHelperText error>
          <>{errorText}</>
        </FormHelperText>
      )}
    </>
  );
};

export default DatePickerWithLabel;
